import type { GridApi } from "ag-grid-enterprise";
import type { TSaveColumnState } from "components/column-config-views";
import { DESIGN_SCOPE_VIEW_META_FIELD_NAME } from "./design-scope-view-meta";

/** AG Grid colId for the Design Scope log ID column. */
export const DESIGN_SCOPE_ID_COL_ID = "sequence_id";

/**
 * True when the saved / default view already carries at least one column sort.
 * Synthetic view-meta rows are ignored — they never participate in grid sort.
 */
export function designScopeColumnConfigHasSort(
  columnStates: TSaveColumnState | null | undefined
): boolean {
  const columnList = columnStates?.columnList;
  if (!columnList?.length) return false;
  return columnList.some((col) => {
    const name = col.field?.name;
    if (!name || name === DESIGN_SCOPE_VIEW_META_FIELD_NAME) return false;
    return col.field?.sortOrder === "asc" || col.field?.sortOrder === "desc";
  });
}

/**
 * Present ID ascending sort when the applied view/config has no sort.
 * Clears other column sorts so the header shows a single active sort.
 */
export function applyDefaultDesignScopeIdSort(
  api: GridApi | null | undefined
): void {
  if (!api || api.isDestroyed?.()) return;
  if (typeof api.applyColumnState !== "function") return;
  api.applyColumnState({
    state: [{ colId: DESIGN_SCOPE_ID_COL_ID, sort: "asc", sortIndex: 0 }],
    defaultState: { sort: null }
  });
}

/**
 * After a view/config is applied (or when none exists), ensure ID is sorted
 * unless that config already defined a sort.
 */
export function ensureDesignScopeDefaultSort(
  api: GridApi | null | undefined,
  columnStates: TSaveColumnState | null | undefined
): void {
  if (designScopeColumnConfigHasSort(columnStates)) return;
  applyDefaultDesignScopeIdSort(api);
}
